import { ScopeModel } from '@bymason/controller-api-hooks';

export function leafIds(node: ScopeModel): string[] {
  return !node.subscope ? [node.id] : node.subscope.map(leafIds).concat([node.id]).flat();
}
export function flattenScopeParents(scopes: ScopeModel[]): string[] {
  return scopes
    .map((s) => {
      if (s.subscope) {
        return flattenScopeParents(s.subscope).concat(s.id);
      } else {
        return [];
      }
    })
    .flat();
}
